import "bootstrap/dist/css/bootstrap.min.css";
import { allSportsPath, routePaths } from "./constants/routes";
import React, { useState } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "./App.css";
import "./style/stage9.css";
// import Home from "./components/pages/Home"; // landing parked — restore with `/` routes below
import Faq from "./components/pages/faq";
import Signup from "./components/pages/signup";
import Login from "./components/pages/login";
import Openbet from "./components/pages/Openbet/openbet";
import Favorites from "./components/pages/Favorites/favorites";
import { Provider } from "react-redux";
import Dashboard from "./components/pages/dashboard/Dashboard";
import "./Style.css";
import FillOpen from "./components/pages/FillOpen/FillOpen";
import EditProfile from "./components/pages/EditProfile.js/EditProfile";
import Live from "./components/pages/Live/Live";
import History from "./components/pages/History/History";
import LiveMobius from "./components/pages/LiveMobius/LiveMobius";
import ForgotPassword from "./components/pages/ForgotPassword";
import Print from "./components/pages/Print";
import { ToastContainer } from "react-toastify";
import OTPVerification from "./components/pages/OTPVerification";
import ConditionRoute from "./conditionalRoute";
// bootstrap import
import store from "./store";
import HelperRoute from "./helperRoute";
import WebsiteDocumentHead from "./components/common/WebsiteDocumentHead";
import ChangePassword from "./components/pages/ChangePassword/ChangePassword";
import Wallet from "./components/pages/Wallet";
import EmailVerification from "./components/pages/emailVerification";

import TwoFactorAuth from "./components/pages/TwoFactorAuth/TwoFactorAuth";
import ContactUs from "./components/pages/ContactUs";
import SupportTicket from "./components/pages/SupportTicket";

// import Context
import SocketContext from "./components/context/SocketContext";
import { socket } from "./components/config/socketConnectivity";
import StaightBetPage from "./components/pages/staightPage/staightBetPage";
import NotFoundPage from "./components/pages/notFoundPage/notFoundPage";
import CallBet from "./components/pages/Callbet/callbet";
import InfoPage from "./components/pages/InfoPage";
import GeoGate from "./components/common-components/GeoGate";
import AmoeRequest from "./components/pages/Amoe/AmoeRequest";
import KycVerification from "./components/pages/Kyc/KycVerification";
import DtsWallet from "./components/pages/DtsWallet";
import Storefront from "./components/pages/Storefront";
import { useComplianceConfig } from "./utility/useComplianceConfig";
import Redemption from "./components/pages/Redemption";
import { CoinModeProvider } from "./context/CoinModeContext";
import { isDTS } from "./utility/platform";

const App = () => {
  const [globalState, setGlobalState] = useState({
    dashboardSidebar: true,
  });

  // Site settings — including admin-configured vocabulary — load asynchronously
  // after this tree has already rendered. Subscribing at the root re-renders
  // everything once they arrive, so every screen reading getTerm() picks up the
  // operator's wording without each component needing to subscribe itself.
  useComplianceConfig();

  
  return (
    <Provider store={store}>
      <BrowserRouter>
        <SocketContext.Provider value={{ socket, globalState: globalState, setGlobalState: setGlobalState }}>
        <CoinModeProvider>
          <ToastContainer
            limit={3}
            newestOnTop
            autoClose={8000}
            pauseOnHover
            closeOnClick
            draggable={false}
          />
          <HelperRoute />
          <WebsiteDocumentHead />
          <GeoGate>
          <Switch>
            {/* Marketing landing parked — site opens on the board (nav "Dashboard"). */}
            {/* <ConditionRoute exact path="/" component={Home} type={"public"} /> */}
            {/* <ConditionRoute exact path="/home" component={Home} type={"public"} /> */}
            {/* <ConditionRoute exact path="/football" component={Home} type={"public"} /> */}
            <Route
              exact
              path="/"
              render={() => <Redirect to={allSportsPath()} />}
            />
            <Route
              exact
              path="/home"
              render={() => <Redirect to={allSportsPath()} />}
            />
            <Route
              exact
              path="/football"
              render={() => <Redirect to={allSportsPath()} />}
            />
            <ConditionRoute
              exact
              path="/dashboard"
              component={Dashboard}
              type={"private"}
            />
            <ConditionRoute
              exact
              path={routePaths("straightBet", "/:id?")}
              component={StaightBetPage}
              type={"public"}
            />
            <ConditionRoute
              exact
              path="/dashboard/:id"
              component={Dashboard}
              type={"private"}
            />
            <Route
              exact
              path="/verify-old-email/:authToken"
              component={EmailVerification}
            />
            <Route
              exact
              path="/verify-new-email/:authToken"
              component={EmailVerification}
            />
            <Route
              exact
              path="/email-verification/:authToken"
              component={EmailVerification}
            />

            <ConditionRoute
              exact
              path="/fillopen"
              component={FillOpen}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/profile"
              component={EditProfile}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/twofactorauth"
              component={TwoFactorAuth}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/live"
              component={Live}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/livemobius"
              component={LiveMobius}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/favorites"
              component={Favorites}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/history"
              component={History}
              type={"private"}
            />

            <ConditionRoute
              exact
              path="/faq"
              component={Faq}
              type={"public"}
            />
            <ConditionRoute
              exact
              path="/info/:slug"
              component={InfoPage}
              type={"public"}
            />
            <ConditionRoute
              exact
              path="/signup"
              component={Signup}
              type={"auth"}
            />
            <ConditionRoute
              exact
              path="/login"
              component={Login}
              type={"auth"}
            />
            <ConditionRoute
              exact
              path="/forgot-password"
              component={ForgotPassword}
              type={"public"}
            />
            <ConditionRoute
              exact
              path={routePaths("openBet")}
              component={Openbet}
              type={"private"}
            />
            <ConditionRoute
              exact
              path={routePaths("callBet")}
              component={CallBet}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/print"
              component={Print}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/otpverification"
              component={OTPVerification}
              type={"public"}
            />
            <ConditionRoute
              exact
              path="/changePassword"
              component={ChangePassword}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/wallet"
              component={isDTS() ? DtsWallet : Wallet}
              type={"private"}
            />
            <ConditionRoute exact path="/storefront" component={isDTS() ? Storefront : NotFoundPage} type={"public"} />
            <ConditionRoute exact path="/store" component={isDTS() ? Storefront : NotFoundPage} type={"public"} />
            <ConditionRoute exact path="/redeem" component={isDTS() ? Redemption : NotFoundPage} type={"private"} />
            <ConditionRoute
              exact
              path="/amoe"
              component={AmoeRequest}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/kyc"
              component={KycVerification}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="/contact_us"
              component={ContactUs}
              type={"public"}
            />
            <ConditionRoute
              exact
              path="/support_ticket"
              component={SupportTicket}
              type={"private"}
            />
            <ConditionRoute
              exact
              path="*"
              component={NotFoundPage}
              type={"public"}
            />
          </Switch>
          </GeoGate>
          </CoinModeProvider>
        </SocketContext.Provider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
